import styled from 'styled-components'
import { Theme } from 'styles/Themes'

interface Prop {
  red?: boolean
  handleGenericDelete?: () => void
}

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #cccccc80;
`
export const PopUpContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0px 0px 24px 0px #00000029;
  border-radius: 16px;
  background-color: #ffffff;
  padding: 40px;
  .red-icon {
    filter: invert(13%) sepia(77%) saturate(7263%) hue-rotate(0deg)
      brightness(98%) contrast(114%);
    height: 24px !important;
    width: 24px !important;
  }
  .alert-title-container {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    gap: 10px;
  }
  .big-red-title {
    font-size: 24px;
    font-weight: 700;
    font-family: ${Theme.fontFamily.SECONDARY};
    text-align: left;
    color: #ff0000;
    line-height: 29.05px;
  }
  .black-title {
    font-size: 16px;
    font-weight: 700;
    text-align: left;
    margin: 0 0 8px 0;
    color: #1c1d22;
  }
  .black-content {
    font-size: 14px;
    font-weight: 400;
    text-align: left;
    margin: 0 0 16px 0;
    color: #1c1d22;
    line-height: 24px;
  }
  .button-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
`
export const Button = styled.button`
  border-radius: 20px;
  padding: 14px 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  font-family: Inter;
  gap: 8px;
  font-size: 14px;
  font-weight: 700;
  text-align: left;
  background-color: transparent;
  transition: all 0.3s ease;
  border: ${(props: Prop) => {
    if (props.red) return '2px solid #FF0000'
    return '2px solid #1C1D22'
  }};
  color: ${(props: Prop) => {
    if (props.red) return '#FF0000'
    return '#1C1D22'
  }};
  &:hover {
    color: #ffffff;
    background-color: ${(props: Prop) => {
      if (props.red) return '#FF0000'
      return '#1C1D22'
    }};
  }
  cursor: pointer;
  .icon {
    height: 18px;
    width: 18px;
    filter: ${(props: Prop) => {
      if (props.red)
        return 'invert(13%) sepia(77%) saturate(7263%) hue-rotate(0deg) brightness(98%) contrast(114%)'
      return 'none'
    }};
  }
  &:hover .icon {
    filter: invert(95%) sepia(96%) saturate(0%) hue-rotate(137deg)
      brightness(105%) contrast(103%);
  }
`

export const ErrorMsg = styled.div`
  font-family: ${Theme.fontFamily.SECONDARY};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-align: start;
  width: 100%;
  margin-bottom: 16px;
  overflow: hidden;
  color: ${Theme.pallete.SENARY};
`
